import React from "react";
import { PageContainer } from "@amzn/stencil-react-components/page";
import { Col, Hr, Row } from "@amzn/stencil-react-components/layout";
import { H1, H2, Text } from "../../../../components/typography";
import { defaultTextColor } from "../../../../config/palette";
import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { TAKE_BADGE_PHOTO_CAMERA_URL } from "../../../../config/urls";
import { useNavigator } from "../../../../hooks/use-navigator";
import "./styles.scss";
import { useParams } from "react-router";
import * as adobeAnalytics from "../../../../utility/adobe-analytics";
import acceptableImgSrc from "../../images/acceptable-photo.png";
import unacceptableImgSrc from "../../images/unacceptable-photo.png";

export const BadgeCameraRequirementsRoute = () => {
  const [goToCamera] = useNavigator(TAKE_BADGE_PHOTO_CAMERA_URL);
  const { applicationId } = useParams<{
    applicationId: string;
  }>();
  const enableCamera = () => {
    adobeAnalytics.addEventMetric(window, applicationId, "camera enabled", {
      referrer: adobeAnalytics.interpretReferrer(document.referrer),
    });
    goToCamera();
  };

  return (
    <>
      <PageContainer color={defaultTextColor}>
        <Col gridGap="1rem">
          <H1 textAlign="center">Taking a photo requirements</H1>
          <H2 className="do">Do</H2>
          <ul className="rules-list">
            <li>
              <Text>Use environment with a good light</Text>
            </li>
            <li>
              <Text>
                Include your entire face, neck, and part of both shoulders
              </Text>
            </li>
            <li>
              <Text>Use solid white or off-white background</Text>
            </li>
          </ul>
          <H2 className="do">Acceptable Photos</H2>
          <Row flex="row">
            <Col gridGap="1rem">
              <img
                src={acceptableImgSrc}
                className="preview-image"
                alt="Acceptable Photos"
              />
            </Col>
          </Row>
          <H2 className="dont">Don&apos;t</H2>
          <ul className="rules-list">
            <li>
              <Text>
                Wear sunglasses, hats, or anything else that obstructs your
                face. If possible, remove glasses
              </Text>
            </li>
            <li>
              <Text>Use digital camera filters</Text>
            </li>
          </ul>
          <H2 className="dont">Unacceptable Photos</H2>
          <Row width="100%">
            <Col gridGap="1rem">
              <img
                src={unacceptableImgSrc}
                className="preview-image"
                alt="Unacceptable Photos"
              />
            </Col>
          </Row>
          <Hr />
          <Row justifyContent="center">
            <Button onClick={enableCamera} variant={ButtonVariant.Primary}>
              Enable camera
            </Button>
          </Row>
        </Col>
      </PageContainer>
    </>
  );
};
